import styled from 'styled-components';

const StyledPageTitle=styled.p`
  font-size:1.5rem;
  font-weight:600;
  margin-bottom:0px;
`;


export default StyledPageTitle;